import React, { useState } from 'react'
import InnerBanner from '../../../Components/InnerBanner/InnerBanner'
import { Col, Container, Row } from 'react-bootstrap'
import boostYourProfileIcon from '../../../assets/images/boost-icon.png'
import becomeAnAffiliateIcon from '../../../assets/images/affiliate-icon.png'
import whoCanViewMyProfileIcon from '../../../assets/images/view-profile-icon.png'
import messageControlIcon from '../../../assets/images/message-control-icon.png'
import verifyYourProfileIcon from '../../../assets/images/verify-profile-icon.png'
import helpCenterIcon from '../../../assets/images/help-center-icon.png'
import { Link } from 'react-router-dom'
import './index.css'
import CustomButton from '../../../Components/CustomButton'
import DeactivateAccountModal from '../../../Components/DeactivateAccountModal/DeactivateAccountModal'
import DeleteAccountModal from '../../../Components/DeleteAccountModal/DeleteAccountModal'
import BecomeAffiliateModal from '../../../Components/BecomeAffiliateModal/BecomeAffiliateModal'
import BoostProfileModal from '../../../Components/BoostProfileModal/BoostProfileModal'
import HideProfileModal from '../../../Components/HideProfileModal/HideProfileModal'
import MessageControlModal from '../../../Components/MessageControlModal/MessageControlModal'
import VerifyProfileInfoModal from '../../../Components/VerifyProfileInfoModal/VerifyProfileInfoModal'
import VerifyProfileModal from '../../../Components/VerifyProfileModal/VerifyProfileModal'
import LogoutModal from '../../../Components/LogoutModal/LogoutModal'
import { useLogout } from '../../../Hooks/useLogout'
import useUserStore from '../../../Stores/UserStore'

const Settings = () => {
    const { role = 'user' } = useUserStore()
    const [showDeactivateModal, setShowDeactivateModal] = useState(false)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [showBecomeAffiliateModal, setShowBecomeAffiliateModal] = useState(false)
    const [showBoostProfileModal, setShowBoostProfileModal] = useState(false)
    const [showHideProfileModal, setShowHideProfileModal] = useState(false)
    const [showMessageControlModal, setShowMessageControlModal] = useState(false)
    const [showVerifyProfileInfoModal, setShowVerifyProfileInfoModal] = useState(false)
    const [showVerifyProfileModal, setShowVerifyProfileModal] = useState(false)
    const [showLogoutModal, setShowLogoutModal] = useState(false)
    const logoutMutation = useLogout()

    const handleLogoutClick = () => {
        setShowLogoutModal(true)
    }

    const handleLogout = () => {
        logoutMutation.mutate(role)
        setShowLogoutModal(false)
    }
    return (
        <>
            <InnerBanner heading="Settings" />
            <section className="py-sm-5 py-4">
                <Container>
                    <Row className='justify-content-center'>
                        <Col xs={12} sm={6} lg={3} md={4} className='my-3'>
                            <div 
                                className='d-block text-decoration-none h-100'
                                onClick={() => setShowBoostProfileModal(true)}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="support-card h-100">
                                    <h6 className='text-capitalize'>Boost your profile</h6>
                                    <img src={boostYourProfileIcon} alt="Boost your profile" className="img-fluid mx-auto" />
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} lg={3} md={4} className='my-3'>
                            <div 
                                className='d-block text-decoration-none h-100'
                                onClick={() => setShowBecomeAffiliateModal(true)}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="support-card h-100">
                                    <h6 className='text-capitalize'>Become an Affiliate</h6>
                                    <img src={becomeAnAffiliateIcon} alt="Become an Affiliate" className="img-fluid mx-auto" />
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} lg={3} md={4} className='my-3'>
                            <div 
                                className='d-block text-decoration-none h-100'
                                onClick={() => setShowHideProfileModal(true)}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="support-card h-100">
                                    <h6 className='text-capitalize'>Who can view my profile?</h6>
                                    <img src={whoCanViewMyProfileIcon} alt="Who can view my profile?" className="img-fluid mx-auto" />
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} lg={3} md={4} className='my-3'>
                            <div 
                                className='d-block text-decoration-none h-100'
                                onClick={() => setShowMessageControlModal(true)}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="support-card h-100">
                                    <h6 className='text-capitalize'>Message Control</h6>
                                    <img src={messageControlIcon} alt="Message Control" className="img-fluid mx-auto" />
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} lg={3} md={4} className='my-3'>
                            <div 
                                className='d-block text-decoration-none h-100'
                                onClick={() => setShowVerifyProfileInfoModal(true)}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="support-card h-100">
                                    <h6 className='text-capitalize'>Verify your profile</h6>
                                    <img src={verifyYourProfileIcon} alt="Verify your profile" className="img-fluid mx-auto" />
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} lg={3} md={4} className='my-3'>
                            <Link to={'/help-center'} className='d-block text-decoration-none h-100'>
                                <div className="support-card h-100">
                                    <h6 className='text-capitalize'>Help Center</h6>
                                    <img src={helpCenterIcon} alt="Help Center" className="img-fluid mx-auto" />
                                </div>
                            </Link>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} className='mt-4'>
                            <div className="d-flex align-items-center gap-3 flex-wrap justify-content-center">
                                <CustomButton 
                                    className="secondaryButton" 
                                    text="Deactivate My Account"
                                    onClick={() => setShowDeactivateModal(true)}
                                />
                                <CustomButton 
                                    className="secondaryButton" 
                                    text="Delete My Account"
                                    onClick={() => setShowDeleteModal(true)}
                                />
                                <CustomButton 
                                    text="Logout" 
                                    onClick={handleLogoutClick}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Deactivate Account Modal */}
            <DeactivateAccountModal
                show={showDeactivateModal}
                onHide={() => setShowDeactivateModal(false)}
            />

            {/* Delete Account Modal */}
            <DeleteAccountModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
            />

            {/* Become Affiliate Modal */}
            <BecomeAffiliateModal
                show={showBecomeAffiliateModal}
                onHide={() => setShowBecomeAffiliateModal(false)}
            />

            {/* Boost Profile Modal */}
            <BoostProfileModal
                show={showBoostProfileModal}
                onHide={() => setShowBoostProfileModal(false)}
            />

            {/* Hide Profile Modal */}
            <HideProfileModal
                show={showHideProfileModal}
                onHide={() => setShowHideProfileModal(false)}
            />

            {/* Message Control Modal */}
            <MessageControlModal
                show={showMessageControlModal}
                onHide={() => setShowMessageControlModal(false)}
            />

            {/* Verify Profile Info Modal */}
            <VerifyProfileInfoModal
                show={showVerifyProfileInfoModal}
                onHide={() => setShowVerifyProfileInfoModal(false)}
                onVerifyNow={() => {
                    setShowVerifyProfileInfoModal(false);
                    setShowVerifyProfileModal(true);
                }}
            />

            {/* Verify Profile Modal */}
            <VerifyProfileModal
                show={showVerifyProfileModal}
                onHide={() => setShowVerifyProfileModal(false)}
            />

            {/* Logout Modal */}
            <LogoutModal
                show={showLogoutModal}
                onClose={() => setShowLogoutModal(false)}
                onLogout={handleLogout}
                isLoading={logoutMutation.isPending}
            />
        </>
    )
}

export default Settings
